import { render, staticRenderFns } from "./restaurantTable.vue?vue&type=template&id=c4299278&scoped=true&"
import script from "./restaurantTable.vue?vue&type=script&lang=js&"
export * from "./restaurantTable.vue?vue&type=script&lang=js&"
import style0 from "./restaurantTable.vue?vue&type=style&index=0&id=c4299278&scoped=true&lang=css&"
import style1 from "./restaurantTable.vue?vue&type=style&index=1&id=c4299278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4299278",
  null
  
)

export default component.exports